// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.folder-name[data-v-d4b5440a] {\n  color: rgba(0, 0, 0, 0.87);\n}\n.v-treeview-node__label[data-v-d4b5440a] {\n  overflow: initial;\n  text-overflow: initial;\n}\n.folders-column[data-v-d4b5440a] {\n  border-right: solid 1px rgba(0, 0, 0, 0.12);\n}\n", ""]);
// Exports
module.exports = exports;
